module.exports = __webpack_public_path__ + "img/icon-eye.dbebd8e9.svg";